module.exports = __webpack_public_path__ + "static/media/light-v3100-Latin-Cyrillic.aefc004d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/read-beta-2/light-v3100-Latin-Cyrillic.woff2
// module id = 662
// module chunks = 0